import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import { WA_MESSAGES, openWhatsApp } from '../../../config/site';

const OPTIONS = [
  {
    id: 'new-id',
    icon: 'UserPlus',
    color: '#25D366',
    title: 'Open a new gaming ID',
    copy: 'Nitin online book sign up in about two minutes, welcome bonus applied before your first bet.',
    message: WA_MESSAGES.newId,
    cta: 'Create my ID',
  },
  {
    id: 'login',
    icon: 'KeyRound',
    color: '#F0C24B',
    title: 'Login or account help',
    copy: 'Locked out, new phone, or an OTP that never arrived? The desk restores access on the spot.',
    message: WA_MESSAGES.login,
    cta: 'Fix my login',
  },
  {
    id: 'app',
    icon: 'Smartphone',
    color: '#5B8CFF',
    title: 'App download link',
    copy: 'Official Nitin online book app download for Android and iOS, always the latest signed build.',
    message: WA_MESSAGES.appDownload,
    cta: 'Send me the app',
  },
  {
    id: 'cashier',
    icon: 'Banknote',
    color: '#B98CFF',
    title: 'Deposits & withdrawals',
    copy: 'UPI, wallets, net banking or USDT — plus help with anything that looks slow in the cashier.',
    message: WA_MESSAGES.withdrawal,
    cta: 'Talk to the cashier',
  },
  {
    id: 'vip',
    icon: 'Crown',
    color: '#FFB454',
    title: 'VIP limits & cashback',
    copy: 'Higher table limits, monthly cashback on turnover and a dedicated relationship manager.',
    message: WA_MESSAGES.vip,
    cta: 'Ask about VIP',
  },
  {
    id: 'strategy',
    icon: 'Brain',
    color: '#FF3D71',
    title: 'Strategy & coaching',
    copy: 'Free strategy packs, bankroll rules and table selection advice from people who play daily.',
    message: WA_MESSAGES.strategy,
    cta: 'Get the strategy pack',
  },
];

const QuickContactOptions = () => (
  <section className="relative overflow-hidden py-24">
    <span className="aurora right-[-8%] top-[14%] h-96 w-96 bg-royal-violet/25" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="badge-pill"><Icon name="Zap" size={13} /> Quick routes</span>
        <h2 className="mt-6 font-heading text-display font-bold text-white">
          Tell us what you need — we <span className="gold-text">pre-write the message</span>
        </h2>
        <p className="mt-4 text-body-lg text-white/60">
          Tap any card and WhatsApp opens with the right message already typed. No forms, no waiting, no explaining
          yourself twice.
        </p>
      </div>

      <div className="perspective mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {OPTIONS.map((o, i) => (
          <article key={o.id} className="card-3d animate-rise flex flex-col p-7" style={{ animationDelay: `${i * 70}ms` }}>
            <span
              className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10"
              style={{ background: `linear-gradient(160deg, ${o.color}33, ${o.color}0D)` }}
            >
              <Icon name={o.icon} size={25} color={o.color} />
            </span>

            <h3 className="font-heading text-lg font-bold text-white">{o.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-white/55">{o.copy}</p>

            <button onClick={() => openWhatsApp(o.message)} className="btn-3d btn-3d-wa mt-6 w-full !py-3 text-sm">
              <FaWhatsapp size={16} /> {o.cta}
            </button>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default QuickContactOptions;
